import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderSlot as _renderSlot, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent } from "vue"

import { useSlots } from "vue";
import { ArtifactListProps, ArtifactSchema } from "@/types";
import { ArtifactBodyDisplay, ListItem } from "@/components";


/**
 * Displays a list of artifacts.
 */
const __default__ = {
  name: "ArtifactListDisplay",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    artifacts: {},
    itemDataCy: {},
    actionCols: {},
    fullWidth: { type: Boolean },
    dataCy: {}
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const slots = useSlots();

return (_ctx: any,_cache: any) => {
  const _component_q_virtual_scroll = _resolveComponent("q-virtual-scroll")!

  return (_openBlock(), _createBlock(_component_q_virtual_scroll, {
    items: props.artifacts,
    style: {"max-height":"300px"},
    "data-cy": props.dataCy
  }, {
    default: _withCtx(({ item }: { item: ArtifactSchema }) => [
      (_openBlock(), _createBlock(_unref(ListItem), {
        key: item.id,
        clickable: "",
        "action-cols": props.actionCols,
        "data-cy": props.itemDataCy,
        onClick: ($event: any) => (emit('click', item))
      }, _createSlots({
        default: _withCtx(() => [
          _createVNode(_unref(ArtifactBodyDisplay), {
            "display-title": "",
            artifact: item,
            "full-width": props.fullWidth
          }, null, 8, ["artifact", "full-width"])
        ]),
        _: 2
      }, [
        (!!_unref(slots).actions)
          ? {
              name: "actions",
              fn: _withCtx(() => [
                _renderSlot(_ctx.$slots, "actions", { artifact: item })
              ]),
              key: "0"
            }
          : undefined
      ]), 1032, ["action-cols", "data-cy", "onClick"]))
    ]),
    _: 3
  }, 8, ["items", "data-cy"]))
}
}

})